import React from 'react';
import { Form, Input } from 'semantic-ui-react';
import { Label } from './label';
import { FieldError } from './field-error';
import { setupField } from '../utils/form-utils';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function InputField(props: any) {
  const { handleBlur, handleChange, field, error } = setupField(props);
  return (
    <Form.Field inline error={error}>
      <Label>{props.label}</Label>
      <Input
        {...field}
        value={field.value || ''}
        onChange={handleChange}
        onBlur={handleBlur}
        error={error}
        disabled={props.disabled}
      />
      <FieldError {...props}></FieldError>
    </Form.Field>
  );
}
